import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import CampaignService from "../../../_services/CampaignService";

interface Props {
  show: boolean;
  onHide: () => void;
  templateId: number;
  templateName: string;
}

const SendTestEmailModal: React.FC<Props> = ({ show, onHide, templateId, templateName }) => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<any>(null);

  const handleSend = async () => {
    if (!email.trim()) return;
    setSending(true);
    setResult(null);
    try {
      const res = await CampaignService.sendTestEmail(templateId, { email: email.trim() });
      setResult({ success: true, message: res.data?.message || "Test email queued" });
    } catch (err: any) {
      const data = err.response?.data || {};
      const primary = data.error || data.message || err.message || "Failed to send";
      const detail = data.detail;
      setResult({
        success: false,
        message: detail && detail !== primary ? `${primary}: ${detail}` : primary,
      });
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    setEmail("");
    setResult(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>Send Test Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 12 }}>
          Send a test of <strong>{templateName}</strong> to check how it looks in your inbox.
        </p>
        {result ? (
          <div
            style={{
              padding: 12,
              borderRadius: 6,
              background: result.success ? "#d4edda" : "#f8d7da",
              color: result.success ? "#155724" : "#721c24",
              fontSize: 13,
              marginBottom: 12,
            }}
          >
            {result.message}
          </div>
        ) : null}
        <div>
          <label style={{ fontWeight: 500, fontSize: 13, marginBottom: 4, display: "block" }}>
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "1px solid var(--border-strong)",
              borderRadius: 4,
              fontSize: 14,
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSend} disabled={sending || !email.trim()}>
          {sending ? "Sending..." : "Send Test"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendTestEmailModal;
